<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title">Contents</p>
<p class="toc-entry"><a href="#/xhtml/fm01">Author’s Note</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter001"><i>1.</i> I Meet Mr. Drury Lane</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter002"><i>2.</i> I Meet a Dead Man</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter003" title="Link target outside of Sample"><i>3.</i> The Black Box</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter004" title="Link target outside of Sample"><i>4.</i> The Fifth Letter</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter005" title="Link target outside of Sample"><i>5.</i> The Sixth Letter</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter006" title="Link target outside of Sample"><i>6.</i> Enter Aaron Dow</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter007" title="Link target outside of Sample"><i>7.</i> The Noose Tightens</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter008" title="Link target outside of Sample"><i>8.</i> Deus Ex Machina</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter009" title="Link target outside of Sample"><i>9.</i> A Lesson in Logic</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter010" title="Link target outside of Sample"><i>10.</i> Test in a Cell</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter011" title="Link target outside of Sample"><i>11.</i> The Trial</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter012" title="Link target outside of Sample"><i>12.</i> Aftermath</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter013" title="Link target outside of Sample"><i>13.</i> Death of a Man</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter014" title="Link target outside of Sample"><i>14.</i> The Second Section</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter015" title="Link target outside of Sample"><i>15.</i> Escape!!</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter016" title="Link target outside of Sample"><i>16.</i> The Z</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter017" title="Link target outside of Sample"><i>17.</i> I Play the Heroine</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter018" title="Link target outside of Sample"><i>18.</i> Dark Hours</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter019" title="Link target outside of Sample"><i>19.</i> Checkmate</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter020" title="Link target outside of Sample"><i>20.</i> The Tragedy of Z</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter021" title="Link target outside of Sample"><i>21.</i> The Last Clue</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter022" title="Link target outside of Sample"><i>22.</i> The Last Act</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter023" title="Link target outside of Sample"><i>23.</i> The Last Word</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1a189381